import React from "react";
import AssetDetails from "../common/AssetDetails";
import AssetMap from "../common/AssetMap";
import AssetFloorMap from "../common/AssetFloorMap";
import { Body, Title } from "@vds/typography";
import { Tabs, Tab } from "@vds/tabs";
import Error from "@vds/icons/error";
import Battery from "@vds/icons/battery";
import Temperature from "@vds/icons/temperature";
import Location from "@vds/icons/location";
import RightCaret from "@vds/icons/right-caret";
//import { convertReelableBatteryValue } from "../../../global/utility/Utils";
import { Spin } from "antd";
import {
  fetchalertRequest,
  mapDataTabIndex,
} from "../../../store/actions/singleAsset";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateUI } from "../../../store/actions/asset";

let intialValue = [
  { text: "New", value: true },
  { text: "Acknowledged", value: false },
  { text: "Resolved", value: false },
  { text: "Auto Resolved", value: false },
];
function AssetMapView({ deviceData, address, assetid }) {
  const dispatch = useDispatch();
  //const prevAddress = React.useRef(address);
  const {
    alertCounts,
    filters,
    isFloorView,
    selectedLocation,
    floorViewSettings,
    isLoading,
    isAssetLoading,
  } = useSelector((state) => ({
    alertCounts: state.singleAsset.alertCounts,
    filters: state.singleAsset.filters,
    isFloorView: state.asset.ui.isFloorView,
    selectedLocation: state.asset.ui.selectedLocation || null,
    floorViewSettings: state.asset.ui.floorView,
    isLoading: state.asset.isLoading.assetMapLocationAlertsLoader,
    isAssetLoading: state?.asset?.isLoading?.assetList,
  }));
  const getAddressValuue = () => {
    let val = "N/A";

    if (dynamicMetricValues?.longitude && dynamicMetricValues?.latitude) {
      val = `${dynamicMetricValues?.latitude},${dynamicMetricValues?.longitude}`;
    }
    return val;
  };
  
  // let batteryPercentage = "N/A";
  // const isReelableDevice = deviceData?.devicetype
  //   ?.toLowerCase()
  //   .includes("reelable");
  // if (
  //   !isNaN(deviceData?.fields?.battery) &&
  //   deviceData?.fields?.battery !== null
  // ) {
  //   if (isReelableDevice) {
  //     batteryPercentage = `${convertReelableBatteryValue(
  //       deviceData.fields.battery
  //     )}%`;
  //   } else {
  //     if (deviceData.fields.battery === 0) {
  //       batteryPercentage = "0%";
  //     } else {
  //       batteryPercentage = `${
  //         Math.round((deviceData.fields.battery + Number.EPSILON) * 10) / 10
  //       }%`;
  //     }
  //   }
  // }

  // let temperatureValue = "N/A";
  // if (
  //   !isNaN(deviceData?.fields?.temperature) &&
  //   deviceData?.fields?.temperature !== 0
  // ) {
  //   temperatureValue = `${
  //     Math.round(
  //       ((deviceData.fields.temperature * 9) / 5 + 32 + Number.EPSILON) * 10
  //     ) / 10
  //   } F`;
  // } else if (deviceData?.fields?.temperature == 0) {
  //   temperatureValue = "0 F";
  // }

  const dynamicMetricValues = useSelector((state) => {
    const trackData = state?.asset?.assetTrackData || [];
    const currentIndex = state?.asset?.ui?.location?.currentIndex;

    // If currentIndex is explicitly set (e.g., during playback), use it
    if (currentIndex !== undefined && currentIndex !== null && trackData[currentIndex]) {
      return trackData[currentIndex];
    }

    // Otherwise, find the item with the latest timestamp
    if (trackData.length === 0) return {};

    const latestData = trackData.reduce((latest, current) => {
      if (!latest.timestamp) return current;
      if (!current.timestamp) return latest;
      return new Date(current.timestamp) > new Date(latest.timestamp) ? current : latest;
    }, trackData[0]);

    return latestData;
  });
  
  // useEffect(() => {
  //   dispatch(
  //     updateUI({
  //       location: {
  //         currentIndex: dynamicMetricValues?.currentIndex || 0,
  //         datatimestamp: dynamicMetricValues?.datatimestamp || 0,
  //         temperature: dynamicMetricValues?.temperature || "N/A",
  //         battery: dynamicMetricValues?.battery || "N/A",
  //         metrics: {
  //           battery: batteryPercentage,
  //           temperature: temperatureValue,
  //         },
  //       },
  //     })
  //   );
  // }, [batteryPercentage, temperatureValue]);

  // useEffect(() => {
  //   if (dynamicMetricValues?.address !== null) {
  //     prevAddress.current = dynamicMetricValues?.address;
  //   }
  // }, [dynamicMetricValues?.address]);

  const metrics = [
    {
      title: "Alerts",
      value: alertCounts.new || 0,
      icon: <Error size="large" />,
      linkText: "More",
      width: "25%",
      tabIndex: 1,
    },
    {
      title: "Battery",
      value:
        dynamicMetricValues?.battery && dynamicMetricValues?.battery !== "N/A"
          ? `${dynamicMetricValues?.battery}%`
          : "N/A",
      icon: <Battery size="large" />,
      linkText: "Data",
      width: "25%",
      tabIndex: 2,
    },
    {
      title: "Temperature",
      value:
        dynamicMetricValues?.temperature &&
        dynamicMetricValues?.temperature !== "N/A"
          ? `${dynamicMetricValues?.temperature} F`
          : "N/A",
      icon: <Temperature size="large" />,
      linkText: "Data",
      width: "25%",
      tabIndex: 2,
    },
    {
      title: `Location(${dynamicMetricValues?.type || "Unknown"})`,
      value: (
        <div style={{ textWrap: "wrap" }}>
          <div class="location-metric-div">
            {getAddressValuue(dynamicMetricValues?.currentIndex)}
          </div>
        </div>
      ),
      icon: <Location size="small" />,
      span: 8,
      metaData:
        dynamicMetricValues?.address && dynamicMetricValues?.address !== "N/A"
          ? dynamicMetricValues?.address
          : "",
    },
  ];
  useEffect(() => {
    // Fetch alerts for the asset here
    dispatch(
      fetchalertRequest({
        ...filters,
        status: intialValue,
        assetid: assetid,
      })
    );
  }, [assetid]);

  const handleMetricClick = (metric) => {
    dispatch(mapDataTabIndex(metric.tabIndex));
  };

  const handleZoomIn = () => {
    dispatch(
      updateUI({
        floorView: {
          ...floorViewSettings,
          scale: floorViewSettings.scale + 0.1,
        },
      })
    );
  };

  const handleZoomOut = () => {
    dispatch(
      updateUI({
        floorView: {
          ...floorViewSettings,
          scale: floorViewSettings.scale - 0.1,
        },
      })
    );
  };

  const handleDrag = (isDragging) => {
    dispatch(
      updateUI({
        floorView: {
          ...floorViewSettings,
          isDragging: isDragging,
        },
      })
    );
  };

  return (
    <div>
      <AssetDetails />
      <Spin spinning={isLoading}>
        <div className="ats-kpi">
          {metrics.map((metric, index) => (
            <div className="ats-kpi-item" style={{ width: metric.width }}>
              <div
                className="d-flex flex-column justify-content-start align-items-start"
                style={metric?.metaData ? { paddingTop: "13px" } : {}}
              >
                <Body size="medium" bold={false}>
                  {metric?.title}
                </Body>
                <div className="metric-content">
                  <button
                    className="metric-value-container ats-btn-text"
                    onClick={() => handleMetricClick(metric)}
                  >
                    <div className="metric-indicator"></div>
                    <Title size="medium" bold={true}>
                      {metric?.value}
                    </Title>
                    {metric?.icon}
                    <div className="metric-link-text">{metric?.linkText}</div>
                    {index < metrics.length - 1 && <RightCaret size="small" />}
                  </button>
                </div>
                {metric?.metaData && (
                  <Body size="medium" bold={false}>
                    {metric?.metaData}
                  </Body>
                )}
              </div>
            </div>
          ))}
        </div>
      </Spin>
      {!isFloorView && <AssetMap height={"70dvh"} hasPopup={true} />}
      {isFloorView && (
        <div className="ats-tab-card" style={{ padding: "16px" }}>
          {Array.isArray(selectedLocation?.floors) &&
          selectedLocation?.floors?.length > 0 ? (
            <Tabs
              key={selectedLocation?.id}
              orientation="vertical"
              indicatorPosition="bottom"
              width={"160px"}
              selectedIndex={0}
            >
              {selectedLocation?.floors?.map((floor) => (
                <Tab
                  key={floor?.id + "-single-asset-tabs"}
                  label={floor?.name || " "}
                  onClick={() => {
                    //dispatch(downloadImageRequest(floor?.floorImageId));
                  }}
                >
                  <AssetFloorMap
                    key={floor?.id + "-single-asset-tab"}
                    floor={floor}
                    setting={floorViewSettings}
                    onDrag={handleDrag}
                    onZoomIn={handleZoomIn}
                    onZoomOut={handleZoomOut}
                  />
                </Tab>
              ))}
            </Tabs>
          ) : (
            <Spin spinning={isAssetLoading}>
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ width: "100%", height: "70dvh" }}
              >
                {!isAssetLoading && (
                  <Title size="medium" bold={true}>
                    No floor map available for this location.
                  </Title>
                )}
              </div>
            </Spin>
          )}
        </div>
      )}
    </div>
  );
}

export default AssetMapView;
